import { ContentBuilder, Form } from "@redriver/cinnamon";
import { ColourPicker, UsersTypeAhead } from "components/forms";
import { DepartmentColourNames, DepartmentColourOptions } from "constants";
import { propName } from "modules/helpers";
import { Grid, Popup, Button } from "semantic-ui-react";
import { getUsedDepartmentColours } from "./actions";
import React from "react";
import { getDocumentTypes } from "features/Admin/ListDocumentTypes/actions";

const OrderedListItemManager = ({ list = [], onChange }) => {
  const moveItem = (from, to) => {
    if (to < 0 || to >= list.length) return;
    const newList = [...list];
    const [item] = newList.splice(from, 1);
    newList.splice(to, 0, item);
    onChange && onChange(newList);
  };

  return (
    <div>
      {list.map((item, index) => (
        <div
          key={index}
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          <div style={{ flex: 1 }}>{item}</div>
          <Button
            icon="arrow up"
            onClick={() => moveItem(index, index - 1)}
            disabled={index === 0}
          />
          <Button
            icon="arrow down"
            onClick={() => moveItem(index, index + 1)}
            disabled={index === list.length - 1}
          />
        </div>
      ))}
    </div>
  );
};

const DepartmentForm = ({ formProps }) => {
  const current = formProps.value.documentTypes || [];

  return (
    <Form {...formProps}>
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Form.Input label="Name" field="name" fluid required />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label="Description" field="description" fluid />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            <UsersTypeAhead label="Team Lead" field="leadId" fluid clearable />
          </Grid.Column>

          <Grid.Column>
            <ContentBuilder
              loadAction={getUsedDepartmentColours}
              initialData={[]}
              renderContent={(data) => {
                return (
                  <ColourPicker
                    field="displayColour"
                    label="Assign Colour"
                    colours={Object.values(DepartmentColourOptions).filter(
                      (colourOption) =>
                        !data?.some(
                          (usedColour) => usedColour === colourOption,
                        ),
                    )}
                    onColourHover={(color, event) => {
                      event.target.title =
                        DepartmentColourNames[
                          propName(DepartmentColourOptions, color.hex)
                        ];
                    }}
                  />
                );
              }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Form.Input
              label="Commercial Nominal Code"
              field="commercialNominalCode"
              fluid
            />
          </Grid.Column>
          <Grid.Column>
            <Form.Input
              label="Residential Nominal Code"
              field="residentialNominalCode"
              fluid
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={3}>
          <Grid.Column>
            <Form.Checkbox
              label="Exclude from scheduling"
              field="excludeFromScheduling"
            />
          </Grid.Column>
          <Grid.Column>
            <Form.Checkbox label="Include TPO/CA" field="includeTpo" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            <div>
              <ContentBuilder
                loadAction={getDocumentTypes}
                loadTransform={(data) =>
                  data.map((d) => ({
                    key: d.id,
                    text: d.name,
                    value: d.name,
                  }))
                }
                initialData={[]}
                renderContent={(data) => {
                  return (
                    <h3>
                      Document Types
                      <Popup
                        trigger={<Button icon="plus" />}
                        content="Add Document Type"
                        on="click"
                        position="right center"
                      >
                        <Form.CheckboxGroup
                          className="checkbox-group--stacked"
                          field="documentTypes"
                          label="Select Document Types"
                          options={data || []}
                        />
                      </Popup>
                    </h3>
                  );
                }}
              />
              {current.length > 0 && (
                <div style={{ marginTop: 8 }}>
                  <OrderedListItemManager
                    list={current}
                    onChange={(newList) =>
                      formProps.onChange(
                        "documentTypes",
                        newList,
                        (formData) => ({
                          ...formData,
                          documentTypes: newList,
                        }),
                      )
                    }
                  />
                </div>
              )}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

export default DepartmentForm;
